/**
 * Service: EmailStatusService
 */
angular.module('acme.common.service.emailStatusApi', [
  'acme.common.factory.QueryStringBuilder'
])
.service('EmailStatusApiService',[ '$http', 'QueryStringBuilderFactory', function($http, QueryStringBuilderFactory) {

    return {

      init: function(endpoint) {
        this.service.tenant = endpoint + '/email/status';
        this.service.order = endpoint + '/email/status/order/:id';
      },

      list: function (props) {
        var q = '';
        if(props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['email', 'type', 'status', 'sortDirection', 'sortField', 'pageSize', 'page']
            }
          });
          q = qs.query;
        }
        return $http({
          method: 'get',
          url: this.server.tenant + q
        });
      },
      detail: function (id, props) {
        var url = this.service.order.replace(':id', id),
            q = '';
        if(props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['email', 'type', 'status', 'sortDirection', 'sortField',  'pageSize', 'page']
            }
          });
          q = qs.query;
        }
        return $http({
          method: 'get',
          url: url + q
        });
      },
      service: {
        tenant: '',
        order: ''
      }
    };
    

}]);